import React from 'react'
import classNames from 'classnames';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ReactTooltip from 'react-tooltip'
import { FaInfoCircle } from 'react-icons/fa';

import POLLUTANTS_CONFIG from '../config/Pollutants.json'

const Pollutants = props => (
    <div className="form-input-container">
        <div>
            <b>Chemistry Option</b><FaInfoCircle data-tip data-for="pollutant-info"/>

            <ReactTooltip id='pollutant-info' place="right" type="light" effect="solid">
                Select pollutant for model outputs and chemistry determination.
            </ReactTooltip>
        </div>

        <RadioGroup row key="pollutants" className={classNames(props.classes.margin, props.classes.textField)}>
            {POLLUTANTS_CONFIG.pollutants.map(option => (
                <FormControlLabel
                    key={option.value}
                    control={
                        <Radio
                            name={option.value}
                            checked={props.pollutant === option.value}
                            onChange={props.handleInputChange}
                            value={option.value}
                            inputProps={{radioname:"pollutant"}}
                            color="primary"/>
                    }
                    label={option.label}/>
            ))}
        </RadioGroup>
    </div>
)

export default Pollutants;
